import $ from 'jquery';

const projectsModalCreator = () => {
    if (document.querySelector('.ume-projects-holder')) {
        document.addEventListener('click', ev => {
            if (!ev.target.matches('.ume-starter-project-btn')) return;
            ev.preventDefault();
            const button = ev.target;
            const card = button.parentNode.parentNode.cloneNode(true);
            card.classList.remove('shadow');
            card.style.backgroundColor = "#F3F4F3";
            card.classList.add('ume-projects-modal-card');
            const share = card.getAttribute('data-share');

            const cardBody = card.querySelector('.card-body');
            const cloneButton = cardBody.querySelector('.ume-starter-project-btn');
            const cloneButtonID = cloneButton.id;
            cardBody.removeChild(cloneButton);
            cardBody.style.paddingBottom = '30px';
            if (share === 'yes') {
                cardBody.style.paddingBottom = '';
                const shareLink = document.createElement('a');
                shareLink.setAttribute('data-target', cloneButtonID);
                shareLink.classList.add('ume-project-share-button', 'button-with-share', 'btn', 'btn-outline-menue-font', 'text-menue-font', 'my-4');
                shareLink.innerHTML = 'Teilen';
                cardBody.appendChild(shareLink);
            }
            const modal = document.getElementById('ume-content-modal');
            const modalBody = modal.querySelector('.modal-body');
            modalBody.innerHTML = '';
            const hiddenContent = button.parentNode.querySelector('.ume-project-hidden').cloneNode(true);
            hiddenContent.classList.remove('ume-project-hidden');
            modalBody.appendChild(card);
            modalBody.appendChild(hiddenContent);
            $('#ume-content-modal').modal('show');
            $('#ume-content-modal').on('hide.bs.modal', function (ev) {
                const shareBox = document.querySelector('.ume-project-share-options');
                shareBox.innerHTML = '';
                if (shareBox.classList.contains('ume-project-share-options__show')) {
                    shareBox.classList.remove('ume-project-share-options__show');
                }

            });

        })
    }
}
export default projectsModalCreator;